module.exports = __webpack_public_path__ + "img/Avatar-51.4a485164.svg";